var sticky = function(el){
    var block = el.querySelector('[data-sticky-block]'),
        parent = block.parentNode,
        parentTop = 0,
        totalOffset = 0,
        checkPosition = function(){
            var newParentTop = parent.getBoundingClientRect().top,
                initialTop = parent.getBoundingClientRect().top + pageYOffset,
                docHeight = document.documentElement.clientHeight,
                blockHeight = block.getBoundingClientRect().height,
                max = -initialTop,
                min = docHeight - blockHeight - initialTop,
                offset = newParentTop - parentTop,
                translate;

            //
            if(newParentTop >=0){ // Если родительский элемент не в самом начале страницы, то, пока он видим, смещаем блок на величину прокрутки
                totalOffset = -pageYOffset;
            } else {
                if(docHeight >= blockHeight) totalOffset = max; //если блок меньше страницы, то оставляем наверху
                else totalOffset = Math.max(Math.min(max, totalOffset+offset), min);
            }

            block.style.transform = 'translate(0, '+ totalOffset +'px)';
            parentTop = newParentTop;
        },
        addEvents = function(){
            APP.helpers.throttle('scroll', checkPosition);
            APP.helpers.throttle('resize', checkPosition);
        };

    //
    setTimeout(function(){
        addEvents();
        checkPosition();
        block.style.position='fixed';
        block.style.left='auto';
        block.style.top='auto';
    }, 15000)



};

export {sticky};




































